import { render, staticRenderFns } from "./SettingsRow.vue?vue&type=template&id=73b697b5&"
import script from "./SettingsRow.vue?vue&type=script&lang=ts&"
export * from "./SettingsRow.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports